import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BinaryFunction, UnaryFunction } from '@dice/app/types/dice.types';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'table-column-drop-down',
  templateUrl: './table-column-drop-down.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableColumnDropDownComponent<T> implements OnChanges {
  @Input() cssClass?: string;

  @Input() selectedValue: UnaryFunction<T, string>;

  @Input() element: T;

  @Input() availableValues: UnaryFunction<T, BehaviorSubject<string[]>>;

  @Input() isDisabled: UnaryFunction<T, boolean>;

  @Input() selectedValueChanged: BinaryFunction<T, string>;

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  @Input() columnCssClass?: string; // unused, fixes console error after angular update

  static readonly sortEnabled = true;

  effectiveSelectedValue: string;
  effectiveAvailableValues: string[] | BehaviorSubject<string[]>;
  effectiveDisabled: boolean = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    const { selectedValue, element } = changes;
    if (!!selectedValue && selectedValue.firstChange && !!element) {
      this.init();
    }
  }

  init(): void {
    this.effectiveSelectedValue = this.selectedValue(this.element);
    this.effectiveAvailableValues = this.availableValues(this.element);
    this.effectiveDisabled = this.isDisabled(this.element);
  }

  setSelectedValue($event: string): void {
    this.selectedValueChanged(this.element, $event);
  }
}
